var render = function (_h,_vm) {var _c=_vm._c;return _c('h' + _vm.props.level,{tag:"Component",staticClass:"title",class:'is-' + Math.min(2 + _vm.props.level, 6)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }